<div class="col-12">
  <div class="col-6 flex align-items-center" *ngIf="isAuthorizedSendMail === true && (depositType === DepositDepotExpressEnum.UNIT || depositType === DepositDepotExpressEnum.MAILING || depositType === DepositDepotExpressEnum.ERL )">
    <div class="col-3 flex align-items-center gap-1" *ngIf="showButtonDeposit">
      <p-inputSwitch [(ngModel)]="showDeposit" (onChange)="handleSwitchChange('deposit', $event)"></p-inputSwitch>
      <span>{{'UPLOAD_COMPONENT.SETDEPOSIT_SWITCH_LABEL' | translate}}</span>
    </div>
    <div class="col-3 flex align-items-center gap-1" *ngIf="isAuthorizedSendMail === true">
      <p-inputSwitch [(ngModel)]="showMailing" (onChange)="handleSwitchChange('mailing', $event)"></p-inputSwitch>
      <span>{{'UPLOAD_COMPONENT.SETMAILING_SWITCH_LABEL' | translate}}</span>
    </div>

    <div class="col-3 flex align-items-center gap-1" *ngIf="showButtonMailingBounce">
      <p-inputSwitch *ngIf="isAuthorizedSendMail === true" [(ngModel)]="showMailingBounce" [disabled]="depositType !== DepositDepotExpressEnum.ERL && (!showMailing || showDeposit)" (onChange)="handleSwitchChange('mailingBounce', $event)"></p-inputSwitch>
      <span *ngIf="isAuthorizedSendMail === true">{{'UPLOAD_COMPONENT.SETMAILINGBOUNCE_SWITCH_LABEL' | translate}}</span>
    </div>

    <div class="col-3 flex align-items-center gap-1" *ngIf="depositType !== DepositDepotExpressEnum.ERL">
      <input *ngIf="hasMailingBounce && hasMailing" type="number" min="1" max="99"
             [ngClass]="{'valid': (this.dayBounce && this.dayBounce > 0) , 'not-valid': !this.dayBounce}"
             [(ngModel)]="dayBounce"  (change)="changeDayBounce()" class="inline-input">
    </div>

    <div class="col-3 p-0" *ngIf="depositType === DepositDepotExpressEnum.ERL && hasMailingBounce && hasMailing">
      <div class="col-12 p-0 flex align-items-center gap-3">
        <div class="col-6 p-0">
          <p-dropdown [filter]="false" [options]="typeBounceItems$ | async" class="dropdown-type-bounce"
                      (ngModelChange)="onTypeBounceChange($event)" [(ngModel)]="typeBounce"></p-dropdown>
        </div>
        <div class="col-5 p-0 align-right" *ngIf="typeBounce === TypeBounceEnum.DAY">
          <span class="p-float-label">
            <input id="bounceDay"
                   [ngClass]="{'valid': (this.dayBounce && this.dayBounce > 0) , 'not-valid': !this.dayBounce}"
                   (change)="changeDayBounce()"
                   [(ngModel)]="dayBounce" type="number" min="1" max="99" pInputText>
            <label for="bounceDay">{{'UPLOAD_COMPONENT.BOUNCE_DAY' | translate}}</label>
          </span>
        </div>
      </div>
    </div>

  </div>
  <div class="col-12 align-right" *ngIf="depositType === DepositDepotExpressEnum.SPOOL || isAuthorizedSendMail === false">
    <button [disabled]="!nextEnabled()" type="button" [icon]="'fa fa-hand-o-right'"
            [label]="'COMMON.NEXT' | translate" pButton (click)="storeDepositOptions()"></button>
  </div>
  <div class="col-6 align-right" *ngIf="isAuthorizedSendMail === true && (depositType === DepositDepotExpressEnum.UNIT || depositType === DepositDepotExpressEnum.MAILING)">
    <button [disabled]="!nextEnabled()" type="button" [icon]="'fa fa-hand-o-right'"
            [label]="'COMMON.NEXT' | translate" pButton (click)="storeDepositOptions()"></button>
  </div>

  <div class="col-6 align-right" *ngIf="isAuthorizedSendMail === true && depositType === DepositDepotExpressEnum.ERL">
    <button [disabled]="!nextEnabledERL()" type="button" [icon]="'fa fa-hand-o-right'"
            [label]="'COMMON.NEXT' | translate" pButton (click)="storeDepositOptions()"></button>
  </div>
</div>

<div class="col-12">
  <div class="col-6">
    <div class="col-12" *ngIf="(depositType !== DepositDepotExpressEnum.ERL && !(hasMailing && !hasDeposit && !hasMailingBounce)) || (depositType === DepositDepotExpressEnum.ERL && hasMailingBounce)">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.UPLOAD_PARAMS' | translate">
        <div class="col-12">
          <div class="col-3 option-label">{{'UPLOAD_COMPONENT.RECTO_TITLE' | translate}}</div>
          <div class="col-2">
            <p-radioButton name="rectoVerso" value="RS" [label]="'UPLOAD_COMPONENT.RECTO_SIMPLE' | translate"
                           [(ngModel)]="printingType" inputId="preopt1"></p-radioButton>
          </div>
          <div class="col-1"></div>
          <div class="col-2">
            <p-radioButton name="rectoVerso" value="RV" [label]="'UPLOAD_COMPONENT.RECTO_VERSO' | translate"
                           [(ngModel)]="printingType" inputId="preopt2"></p-radioButton>
          </div>
        </div>

        <div class="col-12">
          <div class="col-3">
            <div class="col-12 option-label">{{'UPLOAD_COMPONENT.POSTAGE' | translate}}</div>
            <div class="col-12" *ngIf="postageConfig && postageConfig.label">{{postageConfig.label}}</div>
          </div>
          <div class="col-6 postage">
            <p-dropdown [options]="postages" [style]="{'width':'100% !important'}"
                        [(ngModel)]="selectedPostage" (onChange)="initEnvelope()" [group]="true"
                        [autoDisplayFirst]="false"></p-dropdown>
          </div>
          <div class="col-3"></div>
        </div>
        <div class="col-12">
          <div class="col-6">
            <div class="col-6 option-label">{{'UPLOAD_COMPONENT.ENVELOPE' | translate}}</div>
            <div class="col-6">
              <p-dropdown [options]="envelopes" [(ngModel)]="selectedEnvelope"></p-dropdown>
            </div>
          </div>
          <div class="col-6"></div>
        </div>
        <div *ngIf="encarts.length > 0" class="col-12">
          <div class="col-6">
            <div class="col-6 option-label">{{'UPLOAD_COMPONENT.UPLOAD_ENCART' | translate}}</div>
            <div class="col-6">
              <p-multiSelect [options]="encarts"
                             [filter]="false" [showToggleAll]="false"
                          [(ngModel)]="selectedEncart" [group]="false"
                             [maxSelectedLabels]="3"
                             (onChange)="verifySelectedEncartLength()"
                          ></p-multiSelect>
            </div>
          </div>
          <div class="col-6"></div>
        </div>
        <div class="col-12" *ngIf="postageConfig && postageConfig.notes">
          <div class="col-12" *ngFor="let note of postageConfig.notes">{{note}}</div>
        </div>
      </p-fieldset>
    </div>
    <!-- New Mail areas section -->
    <div class="col-12" *ngIf="hasMailing && depositType !== DepositDepotExpressEnum.ERL">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.SENDMAIL_PARAMS' | translate">
        <div class="col-12">
          <div class="col-6">
            <label for="template">{{'UPLOAD_COMPONENT.SENDMAIL_POSTAGE' | translate}}</label>
          </div>
          <div class="col-6 postage">
            <p-dropdown id="template" [options]="templates" [style]="{'text-align': 'center','width':'100% !important'}"
                      [(ngModel)]="selectedTemplate" [group]="true"
                      [autoDisplayFirst]="false"></p-dropdown>
          </div>
        </div>

        <div class="col-12">
          <div class="col-6">
            <label for="responseMail">{{'UPLOAD_COMPONENT.SENDMAIL.RESPONSE' | translate}}</label>
          </div>
          <div class="col-6 input-container">
            <input pInputText id="responseMail" class="custom-input" [(ngModel)]="responseMail"
                   [ngClass]="{'valid': isValidMail(responseMail), 'not-valid': !isValidMail(responseMail)}">
          </div>
        </div>
        <div class="col-12" *ngIf="depositType === DepositDepotExpressEnum.UNIT" >
          <div class="col-6">
            <label for="recipient">{{'UPLOAD_COMPONENT.SENDMAIL.RECIPIENT' | translate}}</label>
          </div>
          <div class="col-6 input-container">
            <input pInputText id="recipient" class="custom-input" [(ngModel)]="recipient"
                   [ngClass]="{'valid': isValidMail(recipient), 'not-valid': !isValidMail(recipient)}"/>
          </div>
        </div>
        <div class="col-12">
          <div class="col-6">
            <label for="alias">{{'UPLOAD_COMPONENT.SENDMAIL.ALIAS' | translate}}</label>
          </div>
          <div class="col-6 input-container">
            <input pInputText id="alias" class="custom-input" [(ngModel)]="alias"
                   [ngClass]="{'valid': (this.alias && this.alias.length > 3) , 'not-valid': !this.alias}"/>
          </div>
        </div>
        <div class="col-12">
          <div class="col-6">
            <label for="subject">{{'UPLOAD_COMPONENT.SENDMAIL.SUBJECT' | translate}}</label>
          </div>
          <div class="col-6 input-container">
            <input pInputText id="subject" class="custom-input" [(ngModel)]="subject"
                   [ngClass]="{'valid': (this.subject && this.subject.length > 3) , 'not-valid': !this.subject}"/>
          </div>
        </div>
      </p-fieldset>
    </div>

    <div class="col-12">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.UPLOAD_COMPOSITION' | translate">
        <div class="col-6">
          <div class="col-12">
            <div class="col-6">
              <p-inputSwitch (onChange)="setFDPFlag($event)"></p-inputSwitch>
              <span class="switch-span">{{'UPLOAD_COMPONENT.FDP_SWITCH_LABEL' | translate}}</span>
            </div>
            <div class="col-6" *ngIf="hasFDP">
              <p-dropdown [options]="choicesFDP" [style]="{'min-width':'200px'}"
                          [(ngModel)]="positionFDP"></p-dropdown>
            </div>
          </div>
          <div class="col-12">
            <div class="col-6">
              <p-inputSwitch (onChange)="setSignatureFlag($event)"></p-inputSwitch>
              <span class="switch-span">{{'UPLOAD_COMPONENT.SIG_SWITCH_LABEL' | translate}}</span>
            </div>
          </div>
          <div class="col-12">
            <p-inputSwitch (onChange)="setAnnexesFlag($event)"></p-inputSwitch>
            <span class="switch-span">{{'UPLOAD_COMPONENT.ANNEX_SWITCH_LABEL' | translate}}</span>
          </div>
        </div>
      </p-fieldset>
    </div>

  </div>

  <div class="col-6">
    <div class="col-12" *ngIf="hasFDP">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.FDP_FILE_SELECTION' | translate">
        <app-files-upload
          filesTitle=""
          [moreThanOneFile]="false"
          [acceptedFiles]="['pdf']"
          [optional]="false"
          (isValid)="updateUploadValidity(FileStatus.FDP, $event)"
          (selectedFiles)="setFDPFile(FileStatus.FDP, $event)">
        </app-files-upload>
      </p-fieldset>
    </div>

    <div class="col-12" *ngIf="hasSignature">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.ISG_FILE_SELECTION' | translate">
        <app-files-upload
          filesTitle=""
          [moreThanOneFile]="false"
          [acceptedFiles]="['jpeg', 'png', 'gif']"
          [optional]="false"
          (isValid)="updateUploadValidity(FileStatus.SIG, $event)"
          (selectedFiles)="setSignatureFile(FileStatus.SIG, $event)">
        </app-files-upload>
      </p-fieldset>
    </div>

    <div class="col-12" *ngIf="hasAnnexes">
      <p-fieldset [legend]="'UPLOAD_COMPONENT.ANNEX_FILE_SELECTION' | translate">
        <app-files-upload filesTitle=""
                          [moreThanOneFile]="true"
                          [acceptedFiles]="getListOfAcceptedFiles(FileStatus.ANNEX)"
                          [optional]="false"
                          (isValid)="updateUploadValidity(FileStatus.ANNEX, $event)"
                          (selectedFiles)="setAnnexes(FileStatus.ANNEX, $event)"></app-files-upload>
      </p-fieldset>
    </div>
  </div>
</div>
